











import { Vue, Component, Prop } from "vue-property-decorator";
import ProductCardInner from "@/components/ProductCardInner.vue";

@Component({
  components: {
    ProductCardInner,
  },
})
export default class ProductCard extends Vue {
  @Prop({ default: "normal" }) readonly type!: string;
  @Prop({ default: "" }) readonly highlight!: string;
  @Prop({ default: "" }) readonly higlightNumber!: string;
  @Prop() readonly product!: MerchantProduct;
  @Prop() readonly lineItem!: MerchantCartItem;
}
